import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FireflyIconNotificationButtonComponent } from './icon-notification-button/icon-notification-button.component';
import { FireflyRedirectButtonComponent } from './redirect-button/redirect-button.component';

@NgModule({
  imports: [CommonModule],
  declarations: [FireflyRedirectButtonComponent, FireflyIconNotificationButtonComponent],
  exports: [FireflyRedirectButtonComponent, FireflyIconNotificationButtonComponent]
})
export class FireflyButtonsModule {}
